// extracted by mini-css-extract-plugin
module.exports = {"langBtn":"LanguageSwitch_langBtn__3w9sU","inactive":"LanguageSwitch_inactive__zI8if","active":"LanguageSwitch_active__1Sjf9"};